import { CustomDialogProps } from "@mirage/contracts/CustomDialogProps";
import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { atom, useRecoilValue } from "recoil";
import "./ConfirmActionDialog.css";

export interface ConfirmDialogProps extends CustomDialogProps {
    onReject?: () => void;
    onConfirm?: () => void;
    onConfirmColor?: "inherit" | "primary" | "secondary" | "success" | "error" | "info" | "warning";
    onConfirmLabel?: string;
    onRejectLabel?: string;
    onConfirmDisabled?: boolean;
    fullWidth?: boolean;
}

export const confirmDialogState = atom({
    key: "confirmDialogState",
    default: { open: false } as ConfirmDialogProps,
});

const ConfirmActionDialog = () => {
    const state = useRecoilValue(confirmDialogState);
    function getTitle(header?: string | JSX.Element) {
        if (typeof header === "string") {
            return <DialogTitle className="confirmActionDialog__title">{header}</DialogTitle>;
        }
        if (typeof header === "object") {
            return header;
        }
        return null;
    }
    const title = getTitle(state.header);

    if (!state.open) {
        return null;
    }
    return (
        <Dialog maxWidth="lg" fullWidth={state.fullWidth} open={state.open} className="confirmActionDialog" PaperProps={{ sx: { overflow: "hidden" } }}>
            {title}
            <DialogContent dividers className="confirmActionDialog__content">
                <Box className="confirmActionDialog__content__mutation">{state.mutation}</Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={state.onReject} variant="outlined">
                    {state.onRejectLabel ? state.onRejectLabel : "No"}
                </Button>
                <Button autoFocus onClick={state.onConfirm} variant="contained" color={state.onConfirmColor || "primary"} disabled={state.onConfirmDisabled}>
                    {state.onConfirmLabel ? state.onConfirmLabel : "Yes"}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmActionDialog;
